import React from 'react';
import NavAdmin from '../nav-admin/nav-admin';

const HeaderHealthcare = () => (
    <header className="HeaderHealthcare">
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm box-shadow admin-custom-navbar" aria-label="Directory search header bar with admin navigation">
            <div className="container w-max2">
                <h5 className="sp-mx" id="directorysearch-header-title">
                    <i className="bi bi-journal-medical" aria-hidden="true"></i>
                    <span className="spacer-margin2 v-set4">HEALTH CARE</span>
                </h5>
                <NavAdmin />
            </div>
        </nav>
    </header>
);


export default HeaderHealthcare;
